import React, { Component, Fragment } from "react";
import "moment/locale/fr";

// import ImportAction from "./ImportAction";
import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import actionsListColumn from "./ActionsList.utils";

class ActionsList extends Component {
  componentDidMount() {
    this.props.init("actions");
  }

  render() {
    const { actionsList, page, pages, pageSize, nbItems, getNext } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des actions</h2>
        </div>
        <div class="p-content-page-center-content">
          <List columns={actionsListColumn} data={actionsList} defaultText="Aucune action trouvée." />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default ActionsList;



// WEBPACK FOOTER //
// src/containers/admin/actions/ActionsList.js